import { Calculator, ClipboardList, FileText, Gavel } from "lucide-react";
import { primaryNav, secondaryNav, tradeNav, tradesIcon, type NavItem } from "@/lib/nav-items";

const [homeTab, jobsTab, shopTab] = primaryNav;

export const planItem: NavItem = {
  path: "/jobs?tool=plan",
  label: "Project plan",
  icon: ClipboardList,
  desc: "Every job with its trades, drawings, estimate and quotes",
};
export const estimatesItem: NavItem = {
  path: "/jobs?tool=estimate",
  label: "Estimates",
  icon: Calculator,
  desc: "Priced takeoffs from every trade",
};
export const bidsItem: NavItem = {
  path: "/jobs?tool=bids",
  label: "Bids",
  icon: Gavel,
  desc: "Subcontractor quotes vs. your estimate",
};
export const reportsItem: NavItem = {
  path: "/jobs?tool=reports",
  label: "Reports",
  icon: FileText,
  desc: "Field reports & exports",
};

export interface NavRow {
  item: NavItem;
  nested?: boolean;
}

export interface NavGroup {
  label: string;
  rows: NavRow[];
}

/** One nav tree shared by the desktop sidebar and the mobile drawer. */
export const navGroups: NavGroup[] = [
  { label: "", rows: [{ item: homeTab }] },
  {
    label: "Trades",
    rows: [
      { item: { path: "/trades", label: "All trades", icon: tradesIcon, desc: "Every trade hub" } },
      ...tradeNav.map((item) => ({ item, nested: true })),
    ],
  },
  {
    label: "Work",
    rows: [
      { item: jobsTab },
      { item: planItem, nested: true },
      { item: estimatesItem, nested: true },
      { item: bidsItem, nested: true },
      { item: reportsItem, nested: true },
      { item: shopTab },
    ],
  },
  { label: "App", rows: secondaryNav.map((item) => ({ item })) },
];
